import React from 'react';
import { motion } from 'framer-motion';
import { Book } from 'lucide-react';
export function ValueStack() {
  return <section className="py-24 px-4 relative" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-zenith-card to-zenith-bg border border-zenith-red/20 rounded-2xl p-8 md:p-12 shadow-[0_0_40px_rgba(153,27,27,0.1)] relative overflow-hidden" data-id="element-78">
          {/* Decorative top border */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-zenith-red to-transparent" data-id="element-79" />

          <div className="flex items-start mb-8 pb-8 border-b border-white/10" data-id="element-80">
            <Book className="w-10 h-10 text-zenith-red mr-5 shrink-0" data-id="element-81" />
            <div data-id="element-82">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-83">
                Ebook Protocolo Zenith
              </h3>
              <p className="text-zenith-muted text-lg" data-id="element-84">
                60 Páginas de Ingeniería Crediticia DIY
              </p>
            </div>
          </div>

          <div className="space-y-4 mb-10" data-id="element-85">
            <div className="flex justify-between items-center text-lg text-zenith-muted" data-id="element-86">
              <span data-id="element-87">Valor Real:</span>
              <span className="line-through decoration-zenith-red/50 decoration-2" data-id="element-88">
                $47.00
              </span>
            </div>
            <div className="flex justify-between items-center text-2xl md:text-3xl font-bold text-white bg-zenith-red/10 p-4 rounded-lg border border-zenith-red/20" data-id="element-89">
              <span data-id="element-90">Tu Inversión Hoy:</span>
              <span className="text-zenith-red" data-id="element-91">$6.83</span>
            </div>
          </div>

          <div className="text-center" data-id="element-92">
            <p className="text-white/80 font-medium tracking-wide uppercase text-sm mb-2" data-id="element-93">
              Acceso Inmediato al Comprar
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}